<script>
    import MyTab from "./Tab.svelte";

    export let results = undefined;
    export let privateVersion = undefined;
</script>

<MyTab result={results[2]}
       resultVacation={results[3]}
       resultYearWithVacation={results[0]}
       resultYearWithoutVacation={results[1]}
       {privateVersion}
       check="z"/>